export const INTERPRETATIONS_PREFIX =
    "On the basis of case history, behavioral observations and test findings";
